export default __webpack_public_path__ + "static/media/GreenFrame06.5fcd8d88.png";